/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input1_inner[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
